export const columns = function() {
  return [
    {
      prop: 'operate_time',
      label: '日志时间',
      minWidth: 200
    },
    {
      prop: 'job_number',
      label: '工号',
      minWidth: 100
    },
    {
      prop: 'user_name',
      label: '姓名',
      minWidth: 100
    },
    {
      prop: 'operate_content',
      label: '描述',
    }
  ]
} 

export default {}